<template>
    <div class="container-list">
        <div class="common-page common-head">
            <div class="common-page common-head-title">
                <i class="icon-tr--detailed" style="padding-right: 5px"></i>
                巡查区域管理
            </div>
<!--            <div class="common-page common-head-end" @click="$router.back()">-->
<!--                <i class="icon-tr-sign-out"></i>-->
<!--            </div>-->

        </div>
                 <ul class="tab-wrap" style="border:none" >
      <li
        :class="`tab-btn ${nowIndex == index && 'active'}`"
        @click="changeTab(index,tab)"
        v-for="(tab, index) in tabList"
      >
        {{tab }}
      </li>
    </ul>
          <div class="ml20  f18 blue cursor" @click="$router.back()">
      <i class="el-icon-back"></i> 返回
    </div>
        <div class="common-page common-body">
        <div class="flex" style="justify-content:flex-end" >
                 <div class="btn ml10" @click="addList()">
          <i class="icon-tr-newly-added"></i>新增
        </div>
        </div>
            <div class="common-page common-list">
                 <table class="common-table mt20">
        <thead>
          <tr class="mt10">
            <th >
              巡查区域
            </th>
             <th >
              区域唯一标识
            </th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in list" :key="item">
            <td
              class="common-add"
            
            >
              <el-input
                placeholder="请输入"
                v-model="item.x_company_area"
              ></el-input>
           
       
            </td>
               <td
              class="common-add"
            
            >
              <el-input
                placeholder="请输入"
                v-model="item.x_company_id"
              ></el-input>
           
       
            </td>
            <td class="td-btn">
              <a class="clear-data" @click="del(index)">
                <i class="icon-tr-delete"></i>
              </a>
        
            </td>
          </tr>
        </tbody>
      </table>
          <div class="btn-box">
                <div class="l-btn" @click="onSubmit">保存</div>
                <div class="l-btn ml20" @click="$router.back()">返回</div>
            </div>
            </div>
         
        </div>

 
    </div>
</template>

<script>

    export default {
        data(){
            return{
                list:[
                    {x_company_area:'',x_company_id:""}
                ],
               
            
            }
        },
        created(){
            this.getList()
        },
        methods:{
            changeTab(index,it) {
      this.nowIndex = index;
      this.params.inspectionType= this.nowIndex==0 ? 1 : 2
      this.getList()
    },
       onSubmit(){
          if(this.check()){
              this.$post('/xuncha/xcareaadd',{get_area:this.list}).then(res=>{
            // this.$message.success('操作成功')
            this.$message({
									message: "操作成功",
									type: 'success',
									duration: 700,
								});
})
          }
       },
       check(){
         var isCheck =true
          this.list.map(item=>{
            if(!item.x_company_id){
              this.$message.warning('请输入唯一标识')
              isCheck=false
            }
          })
          return  isCheck
       },
         
         getList(){
                // getUserList(this.params).then(res=>{
                //     this.total = res.data.count
                //     this.list = res.data.list
                // }).catch(err=>{

                // })
                this.$post('/xuncha/xunchaareadetail').then(res=>{
                    this.list=res.data

                })                
            },
            del(index){
              var x_company_id = this.list[index].x_company_id
              this.$post('/xuncha/xcareaExist',{x_company_id}).then(res=>{
                if(res.code<1000){
                  if(res.data){
                      this.list.splice(index,1)
                  }else{
                    this.$message.warning('该区域已绑定巡查点位')
                  }
                }
              })
            },
            addList(){
                this.list.push({x_company_area:'',x_company_id:''}
)
            }
        }
    }
</script>

<style scoped>

</style>